import { emptySplitApi } from './index'

export const searchEngineCAApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        searchBySearchTypeCA: builder.mutation({
            query: ({searchType, ...model}) => ({
                url: `api/v1/search-engine-ca-service/search/${searchType}`,
                method: "POST",
                body: model
            }),
        }),
        searchByGivingHistoryCA: builder.mutation({
            query: ({searchType, ...model}) => ({
                url: `api/v1/search-engine-ca-service/search/by-giving-history`,
                method: "POST",
                body: model
            }),
        }),
        getGrantDetailsCA: builder.mutation({
            query: (model) => ({
                url: `api/v2/search-engine-ca-service/search/grant-details/${model.profileId}`,
                method: "POST",
                body: model
            }),
        }),
        crossRefGrantDetailsCA: builder.mutation({
            query: (model) => ({
                url: `api/v2/search-engine-ca-service/search/cross-ref-grant-details/${model.profileId}`,
                method: "POST",
                body: model
            }),
        }),
        searchByNameCA: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-ca-service/search/by-name`,
                method: "POST",
                body: model
            }),
        }),
        searchByNameCAV2: builder.mutation({
            query: (model) => ({
                url: `api/v2/search-engine-ca-service/search/by-name`,
                method: "POST",
                body: model
            }),
            invalidatesTags: () => [{type: "SavedHistory", id: "ByNameCA" }],
        }),
        searchByDirectorCA: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-ca-service/search/by-director`,
                method: "POST",
                body: model
            }),
        }),
        searchByDirectorCAV2: builder.mutation({
            query: (model) => ({
                url: `api/v2/search-engine-ca-service/search/by-director`,
                method: "POST",
                body: model
            }),
            invalidatesTags: () => [{type: "SavedHistory", id: "ByDirectorCA"}],
        }),
        searchByYearCA: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-ca-service/search/by-year`,
                method: "POST",
                body: model
            }),
            invalidatesTags: () => [{type: "SavedHistory", id: "ByYearCA"}],
        }),
        searchByRatingCA: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-ca-service/search/by-rating`,
                method: "POST",
                body: model
            }),
        }),
        searchByCustomCA: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-ca-service/search/by-custom`,
                method: "POST",
                body: model
            }),
        }),
        searchByKeywordCA: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-ca-service/search/by-keywords`,
                method: "POST",
                body: model
            }),
        }),
        getCountriesCA: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-ca-service/country`,
                method: "GET",
            }),
        }),
        getCountiesCA: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-ca-service/country/counties`,
                method: "POST",
                body: model
            }),
        }),
        getCitiesByCountiesCA: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-ca-service/country/cities-by-counties`,
                method: "POST",
                body: model
            }),
        }),
        getEnhancedWordsCAV2: builder.mutation({
            query: (model) => ({
                url: `api/v2/search-engine-ca-service/search/enhancement-words`,
                method: "POST",
                body: model
            }),
        }),
        getEnhancedWords: builder.mutation({
            query: (model) => ({
                url: `api/v2/search-engine-ca-service/search/enhancement-words-2`,
                method: "POST",
                body: model
            }),
        }),
        searchByGivingHistoryCAV2: builder.mutation({
            query: ({searchType, ...model}) => ({
                url: `api/v2/search-engine-ca-service/search/by-giving-history`,
                method: "POST",
                body: model
            }),
            invalidatesTags: () => [{type: "SavedHistory", id: "ByGivingHistoryCA"}],
        }),
        getSearchSummaryCA: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-ca-service/search/search-summary/${model.pageType}`,
                method: "POST",
                body: model
            }),
        }),
    }),
    overrideExisting: false,
});

export const { 
    useSearchBySearchTypeCAMutation,
    useSearchByGivingHistoryCAMutation,
    useGetGrantDetailsCAMutation,
    useSearchByNameCAMutation,
    useSearchByDirectorCAMutation,
    useSearchByYearCAMutation,
    useSearchByRatingCAMutation,
    useSearchByCustomCAMutation,
    useSearchByKeywordCAMutation,
    useGetCountriesCAMutation,
    useGetCountiesCAMutation,
    useGetCitiesByCountiesCAMutation,
    useGetEnhancedWordsCAV2Mutation,
    useSearchByGivingHistoryCAV2Mutation,
    useSearchByDirectorCAV2Mutation,
    useSearchByNameCAV2Mutation,
    useSearchByYearCAV2Mutation,
    useGetEnhancedWordsMutation,
    useCrossRefGrantDetailsCAMutation,
    useGetSearchSummaryCAMutation,
} = searchEngineCAApi;
